import relps from "@/data/forms/mixins/relps.js";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  mixins: [relps],
  computed: {
    ...mapGetters([
      "getUser",
      "getDetail",
      "getRelpsRemote",
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailRelps",
      "getDetailPref",
      "getDetailRev",
      "getDetailRisk",
      "getDetailStats",
      "getDetailLink",
      "getAssetRegister",
      "getAssetRegisterCounter",
      "getMaterialRegister",
      "getMaterialRegisterCounter",
      "getFacilityRegister",
      "getFacilityRegisterCounter",
      "getEquipRegister",
      "getAttachmentList",
      "getAttachmentListCounter",
      "getRiskAnalysisList",
      "getRiskAnalysisListCounter",
      "getSkillsList",
      "getSkillsListCounter",
      "getCompetenciesList",
      "getCompetenciesListCounter",
      "getCertificatesList",
      "getCertificatesListCounter",
      "getLicencesList",
      "getLicencesListCounter",
      "getRiskAssessmentList",
      "getRiskAssessmentListCounter",
      "getRelationshipRegister",
      "getRelationshipRegisterCounter",
      "getRolesList",
      "getRolesListCounter",
      "getMaterialRegister",
      "getMaterialRegisterCounter",
      "getPartsList",
      "getPartsListCounter",
      "getAnalysisList",
      "getAnalysisListCounter",
      "getInventoryList",
      "getInventoryListCounter",
      "getLimitsList",
      "getLimitsListCounter",
      "getResourcesList",
      "getResourcesListCounter",
      "getHazardRegister",
      "getHazardRegisterCounter",
      "getPermitsList",
      "getPermitsListCounter",
      "getTasksList",
      "getTasksListCounter",
      "getResultsList",
      "getResultsListCounter",
      "getMaintActivityList",
      "getMaintActivityListCounter",
      "getAction",
      "getActionNewDocumentList",
      "getDocumentRevsList",
      "getActionRegister",
      "getActionRegisterCounter",
      "getTransitions"
    ])
  },
  methods: {
    enableRelpsRemote(tag) {
      // REMOTE STATS CHECK = TRUE OR FALSE
      let logic = null;
      if (tag !== "G1" && tag !== "M7") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    updateDetailRelpsAndStats() {
      // DEFINE
      let relps = this.getDetailRelps;
      let stats = this.getDetailStats;
      // console.log("UPDATE RELPS AND STATS");
      // UPDATE RELPS AND STATS
      // Note this is combined function
      if (
        this.getDetailRelps !== null &&
        this.getDetailRelps !== undefined &&
        this.getDetailStats !== null &&
        this.getDetailStats !== undefined
      ) {
        // UPDATE STATS
        stats.dedit = moment().format(); // doc. revision
        stats.n = stats.n + 1; // general counter Update

        // UPDATE RELPS

        // RELPS - RISK ANALYSIS
        if (
          this.getRiskAnalysisList !== undefined &&
          this.getRiskAnalysisList !== null &&
          stats.nb1 !== undefined
        ) {
          relps.b1 = this.getRiskAnalysisList;
          stats.nb1 = this.getRiskAnalysisListCounter;
        }

        // RELPS - ACTION REGISTER
        if (
          this.getActionRegister !== undefined &&
          this.getActionRegister !== null &&
          stats.nb3 !== undefined
        ) {
          relps.b3 = this.getActionRegister;
          stats.nb3 = this.getActionRegisterCounter;
        }

        // RELPS - ATTACHMENTS
        if (
          this.getAttachmentList !== undefined &&
          this.getAttachmentList !== null &&
          stats.nd4 !== undefined
        ) {
          relps.d4 = this.getAttachmentList;
          stats.nd4 = this.getAttachmentListCounter;
        }

        // RELPS - ROLES
        // eslint-disable-next-line
        if (
          this.getRolesList !== undefined &&
          this.getRolesList !== null &&
          stats.ng4 !== undefined
        ) {
          relps.g4 = this.getRolesList;
          stats.ng4 = this.getRolesListCounter;
        }

        // RELPS - ASSET REGISTER
        // eslint-disable-next-line
        if (
          this.getAssetRegister !== undefined &&
          this.getAssetRegister !== null &&
          stats.na1 !== undefined
        ) {
          relps.a1 = this.getAssetRegister;
          stats.na1 = this.getAssetRegisterCounter;
        }

        // RELPS - ASSET REGISTER
        // eslint-disable-next-line
        if (
          this.getMaterialRegister !== undefined &&
          this.getMaterialRegister !== null &&
          stats.nl1 !== undefined
        ) {
          relps.l1 = this.getMaterialRegister;
          stats.nl1 = this.getMaterialRegisterCounter;
        }

        // RELPS - FACILITY REGISTER
        // eslint-disable-next-line
        if (
          this.getFacilityRegister !== undefined &&
          this.getFacilityRegister !== null &&
          stats.nf1 !== undefined
        ) {
          relps.f1 = this.getFacilityRegister;
          stats.nf1 = this.getFacilityRegisterCounter;
        }

        // RELPS - EQUIPMENT REGISTER
        // eslint-disable-next-line
        if (
          this.getEquipRegister !== undefined &&
          this.getEquipRegister !== null &&
          stats.ne1 !== undefined
        ) {
          relps.e1 = this.getEquipRegister;
          stats.ne1 = this.getEquipListCounter;
        }

        // RELPS - IMPORTS REGISTER
        // eslint-disable-next-line
        if (
          this.getRelationshipRegister !== undefined &&
          this.getRelationshipRegister !== null &&
          stats.nk4 !== undefined
        ) {
          relps.k4 = this.getRelationshipRegister;
          stats.nk4 = this.getRelationshipRegisterCounter;
        }

        // RELPS - MATERIAL BOM
        // eslint-disable-next-line
        if (
          this.getMaterialRegister !== undefined &&
          this.getMaterialRegister !== null &&
          stats.nl2 !== undefined
        ) {
          relps.l2 = this.getMaterialRegister;
          stats.nl2 = this.getMaterialRegisterCounter;
        }

        // RELPS - ACTIVITY LIST
        if (
          this.getMaintActivityList !== undefined &&
          this.getMaintActivityList !== null &&
          stats.nm1 !== undefined
        ) {
          relps.m1 = this.getMaintActivityList;
          stats.nm1 = this.getMaintActivityListCounter;
        }

        // RELPS - BUSIENSS LIMITS
        // eslint-disable-next-line
        if (
          this.getLimitsList !== undefined &&
          this.getLimitsList !== null &&
          stats.nb7 !== undefined
        ) {
          relps.b7 = this.getLimitsList;
          stats.nb7 = this.getLimitsListCounter;
        }

        // RELPS = MAINT ACTIVITY
        // eslint-disable-next-line
        if (
          this.getMaintActivityList !== undefined &&
          this.getMaintActivityList !== null &&
          this.getMaintActivityListCounter !== undefined &&
          this.getMaintActivityListCounter !== null &&
          stats.nm1 !== undefined
        ) {
          relps.m1 = this.getMaintActivityList;
          stats.nm1 = this.getMaintActivityListCounter;
        }

        // RELPS - INVENTORY LIST
        // eslint-disable-next-line
        if (
          this.getInventoryList !== undefined &&
          this.getInventoryList !== null &&
          stats.nl7 !== undefined
        ) {
          relps.l7 = this.getInventoryList;
          stats.nl7 = this.getInventoryListCounter;
        }

        // PARTS LIST
        // eslint-disable-next-line
        if (
          this.getPartsList !== undefined &&
          this.getPartsList !== null &&
          stats.nl5 !== undefined
        ) {
          relps.l5 = this.getPartsList;
          stats.nl5 = this.getPartsListCounter;
        }

        // RELPS - RISK ASSESSMENTS
        // eslint-disable-next-line
        if (
          this.getRiskAssessmentList !== undefined &&
          this.getRiskAssessmentList !== null &&
          stats.ns2 !== undefined
        ) {
          relps.s2 = this.getRiskAssessmentList;
          stats.ns2 = this.getRiskAssessmentListCounter;
        }

        // RELPS - ENGINGEERING ANALYSIS
        // eslint-disable-next-line
        if (
          this.getAnalysisList !== undefined &&
          this.getAnalysisList !== null &&
          stats.ne3 !== undefined
        ) {
          relps.e3 = this.getAnalysisList;
          stats.ne3 = this.getAnalysisListCounter;
        }

        // RELPS - RESOURCES ESTIMATE
        // eslint-disable-next-line
        if (
          this.getResourcesList !== undefined &&
          this.getResourcesList !== null &&
          stats.nh5 !== undefined
        ) {
          relps.h5 = this.getResourcesList;
          stats.nh5 = this.getResourcesListCounter;
        }

        // RELPS - PERMIT REQUESTS
        // eslint-disable-next-line
        if (
          this.getPermitsList !== undefined &&
          this.getPermitsList !== null &&
          stats.no5 !== undefined
        ) {
          relps.o5 = this.getPermitsList;
          stats.no5 = this.getPermitsListCounter;
        }

        // RELPS - PROCEDURE
        // eslint-disable-next-line
        if (
          this.getTasksList !== undefined &&
          this.getTasksList !== null &&
          stats.nw5 !== undefined
        ) {
          relps.w5 = this.getTasksList;
          stats.nw5 = this.getTasksListCounter;
        }

        // RELPS - RESULTS MANAGEMENT
        // eslint-disable-next-line
        if (
          this.getResultsList !== undefined &&
          this.getResultsList !== null &&
          stats.ne5 !== undefined
        ) {
          relps.e5 = this.getResultsList;
          stats.ne5 = this.getResultsListCounter;
        }

        // RELPS HAZARD - REGISTER
        // eslint-disable-next-line
        if (
          this.getHazardRegister !== undefined &&
          this.getHazardRegister !== null &&
          stats.ns1 !== undefined
        ) {
          relps.s1 = this.getHazardRegister;
          stats.ns1 = this.getHazardRegisterCounter;
        }

        // UPDATE RELPS + STATS
        // console.log("STATS");
        // console.log(stats);
        this.$store.dispatch("changeDetailRelps", relps);
        this.$store.dispatch("changeDetailStats", stats);
      }
    },
    generateSourceFromDetail(detail, type) {
      let tempForm = this.formSourceItem;
      tempForm.ddid = detail.basic.did; // document doc did
      tempForm.dname = detail.basic.title; // document name / title
      tempForm.dtag = detail.basic.tag; // document tag / type of doc
      tempForm.didg = detail.basic.idg; // document id for doc
      tempForm.did = detail.basic.id; // document doc did
      tempForm.cid = this.getUser.pref.select.cid; // company tag
      tempForm.cdid = this.getUser.pref.select.cdid; // company tag;
      tempForm.cname = this.getUser.pref.select.cname; // company tag;; // company legal name
      tempForm.fname = this.getUser.pref.select.fname; // facility name
      tempForm.fid = this.getUser.pref.select.fid; // facility tag
      tempForm.fdid = this.getUser.pref.select.fdid; // facility id
      tempForm.type = type; // idetifies as type of source
      return tempForm;
    }
  }
};
